/**
 * AI 生文 输入框
 * @returns
 */
import React, { useState } from "react";
import {
  Flex,
  IconButton,
  Input,
  Select,
  Tooltip,
  useToast,
} from "@chakra-ui/react";
import {
  RiFolderHistoryLine,
  RiMapPinTimeLine,
  RiSendPlaneFill,
} from "@remixicon/react";
import { useLocation } from "react-router-dom";

type Props = {
  text: string;
  updateValue: (text: string) => void;
  handleSubmit: () => void;
};

const ChatTextInput = (props: Props) => {
  const toast = useToast();
  const location = useLocation();
  const currentUrl = location.pathname;
  const [isOpenContext, setIsOpenContext] = useState<boolean>(false);
  const [searchMode, setSearchMode] = useState<boolean>(true);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    props.updateValue(inputValue);
  };

  const handleWarning = () => {
    if (!isOpenContext) {
      toast({
        title: "当前模式下, 发送消息会携带之前的聊天记录",
        position: "top",
        status: "success",
        duration: 2000,
        isClosable: false,
      });
    } else {
      toast({
        title: "当前模式下, 发送消息不会携带之前的聊天记录",
        position: "top",
        status: "warning",
        duration: 2000,
        isClosable: false,
      });
    }
    setIsOpenContext(!isOpenContext);
  };

  const handleChangeSearchMode = () => {
    setSearchMode(!searchMode);
  };

  return (
    <Flex alignItems="center" p="0 18px" gap={"12px"}>
      {/* {currentUrl === "/ai/writing" && (
        <Tooltip
          label={isOpenContext ? "上下文理解已开启" : "上下文理解已关闭"}
          placement="top"
        >
          <IconButton
            w="20px"
            minW={"20px"}
            h="20px"
            aria-label="上下文理解"
            variant={"unstyle"}
            color={isOpenContext ? "green" : "red"}
            icon={<RiMapPinTimeLine />}
            onClick={handleWarning}
          />
        </Tooltip>
      )} */}

      {/* {currentUrl === "/ai/writing/aisearch" && (
        <>
          <Tooltip label={searchMode ? "摘要模式" : "详细模式"} placement="top">
            <IconButton
              w="20px"
              minW={"20px"}
              h="20px"
              aria-label="搜索模式"
              variant={"unstyle"}
              color={searchMode ? "green" : "red"}
              icon={<RiFolderHistoryLine />}
              onClick={handleChangeSearchMode}
            />
          </Tooltip>

          <Select
            w="96px"
            h="36px"
            fontSize={"14px"}
            color="#8E94A9"
            placeholder="请选择"
          >
            <option value="option1"></option>
          </Select>
        </>
      )} */}

      {/* <Select
        w="150px"
        h="36px"
        fontSize={"14px"}
        color="#8E94A9"
        placeholder="请选择"
      >
        <option value="option1">Option 1</option>
      </Select> */}
      <Input
        flex={1}
        h="36px"
        fontSize={"14px"}
        color="#8E94A9"
        borderWidth="2px"
        bg="#fff"
        value={props.text}
        onChange={handleInputChange}
        placeholder="随时输入你想要了解的任何内容"
      />
      <IconButton
        aria-label="send"
        borderRadius={"4px"}
        minW={"40px"}
        width={"46px"}
        height={"32px"}
        color="#FFFFFF"
        bgColor="#496AE1"
        fontWeight={"normal"}
        fontSize="12px"
        _hover={{
          bgColor: "#3F5BC1",
          color: "#E6E6E6",
        }}
        onClick={props.handleSubmit}
        icon={<RiSendPlaneFill size={"18px"} />}
      >
        发送
      </IconButton>
    </Flex>
  );
};

export default ChatTextInput;
